var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Observable, timer, forkJoin, of } from 'rxjs';
import { map, exhaustMap, retryWhen, delay, take, tap } from 'rxjs/operators';
import { Status } from './order.model';
import { Order } from './order.model';
import { Api } from 'app/core/api.service';
import { camelCaseObject } from 'app/core/case-transform';
import { UserSettingsService } from 'app/user/user-settings.service';
var OrderListService = /** @class */ (function () {
    function OrderListService(_api, _userSettingsService) {
        this._api = _api;
        this._userSettingsService = _userSettingsService;
    }
    /** Возвращает заказы пользователя по фильтру (с заданным типом FilterType и status) */
    OrderListService.prototype.poolByStatus = function (filter) {
        var _this = this;
        return timer(0, 5000)
            .pipe(exhaustMap(function () { return forkJoin(_this.getByStatus(filter), _this._getStatusesOverview(filter.serviceType)); }), map(function (_a) {
            var _b = __read(_a, 2), orders = _b[0], statuses = _b[1];
            return (__assign({}, orders, { statuses: statuses }));
        }), retryWhen(function (errors) { return errors.pipe(tap(console.error), delay(10000), take(10)); }));
    };
    OrderListService.prototype.pool = function (filter) {
        var _this = this;
        return timer(0, 10000)
            .pipe(exhaustMap(function () { return forkJoin(_this.get(filter), _this._getStatusesOverview(filter.serviceType)); }), map(function (_a) {
            var _b = __read(_a, 2), orders = _b[0], statuses = _b[1];
            return (__assign({}, orders, { statuses: statuses }));
        }), retryWhen(function (errors) { return errors.pipe(tap(console.error), delay(10000), take(10)); }));
    };
    OrderListService.prototype.hasOrders = function () {
        var _this = this;
        return timer(0, 5000)
            .pipe(exhaustMap(function () { return _this._getStatusesOverview(_this._userSettingsService.serviceType); }), map(function (statuses) { return statuses.some(function (status) { return status.taskCount > 0; }); }));
    };
    OrderListService.prototype.get = function (filter) {
        var serviceType = filter.serviceType, skip = filter.skip, take = filter.take;
        var params = { skip: skip, take: take };
        return this._api
            .get("/v2/task/" + serviceType + "/search", { params: params })
            .pipe(map(function (response) {
            if (response && response.tasks) {
                return {
                    count: response.count,
                    orders: response.tasks.map(function (order) { return new Order(order); })
                };
            }
            return {
                count: 0,
                orders: []
            };
        }));
    };
    /** Загружает отфильтрованные заказы по типу и статусу */
    OrderListService.prototype.getByStatus = function (filter) {
        var serviceType = filter.serviceType, status = filter.status, skip = filter.skip, take = filter.take;
        var params = { skip: skip, take: take };
        return forkJoin(this._api
            .get("/v2/task/" + serviceType + "/search/" + status, { params: params }), status === Status.InProgress
            ? this._api.get("/v2/task/" + serviceType + "/search/" + Status.Submitted, { params: params })
            : of({ count: 0, tasks: [] }))
            .pipe(map(function (responses) {
            if (responses && responses[0] && responses[0].tasks && responses[1] && responses[1].tasks) {
                return {
                    count: responses[0].count + responses[1].count,
                    orders: responses[0].tasks
                        .concat(responses[1].tasks)
                        .sort(function (a, b) { return Date.parse(b.created) - Date.parse(a.created); })
                        .map(function (order) { return new Order(order); })
                };
            }
            return { count: 0, orders: [] };
        }));
    };
    OrderListService.prototype._getStatusesOverview = function (serviceType) {
        return this._api
            .get("/v2/task/" + serviceType + "/status/overview")
            .pipe(map(function (response) { return (response || []).map(camelCaseObject); }));
    };
    return OrderListService;
}());
export { OrderListService };
